<h1 matDialogTitle>
  <ng-container *ngIf="!data.storage.id">New Storage</ng-container>
  <ng-container *ngIf="data.storage.id">Edit Storage: {{data.testbed?.identifier}}</ng-container>
</h1>
<mat-dialog-content>

  <aw-storage-form [storage]="data.storage" [testbed]="data.testbed" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-storage-form>

</mat-dialog-content>